import { render, staticRenderFns } from "./LocationChange.vue?vue&type=template&id=244d5fc9&scoped=true&"
import script from "./LocationChange.vue?vue&type=script&lang=js&"
export * from "./LocationChange.vue?vue&type=script&lang=js&"
import style0 from "./LocationChange.vue?vue&type=style&index=0&id=244d5fc9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244d5fc9",
  null
  
)

export default component.exports